import React from 'react'

import HomeIcon from '@mui/icons-material/Home';
import TodayIcon from '@mui/icons-material/Today';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AddIcon from '@mui/icons-material/Add';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EventBusyIcon from '@mui/icons-material/EventBusy';

/*
this will store, in an object, the static properties of each route.
the redux store stores the variable properties of each route
*/
const RouteConstants = {
	home: {
		path: "/",
		title: "Home",
		loggedin: true,
		loggedout: true,
		icon: <HomeIcon />,
	},
	courses: {
		path: "/courses",
		title: "Courses",
		subtext: 'Courses and activities available at our U3A',
		card: true,
		loggedin: true,
		loggedout: true,
		icon: <TodayIcon />,
	},
	course: {
		path: "/courses/:courseCode",
		title: "Course Detail",
		loggedin: true,
		loggedout: true, 
	},
	member: {
		path: "/member",
		title: "My Membership",
		subtext: 'User account details',
		card: true,
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <AccountBoxIcon />,
	},
	member_enrolments: {
		path: "/member/enrolments",
		title: "My Enrolments",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <EventAvailableIcon />,
	},
	member_invoices: {
		path: "/member/invoices",
		title: "My Invoices",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <ReceiptIcon />,
	},
	buy_membership: {
		path: "/buy-membership",
		title: "Pay Membership",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <AddIcon />,
	},
	member_absences: {
		path: "/member/absences",
		title: "My Absences",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <EventBusyIcon />,
	},
	cart: {
		path: "/cart",
		title: "Cart",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <ShoppingCartIcon />,
	},
	checkout: {
		path: "/checkout",
		title: "Checkout",
		loggedin: true,
		loggedout: false,
		redirect: '/',
		icon: <CheckCircleRoundedIcon />,
	},
	login: {
		path: "/login",
		title: "Log in",
		subtext: 'Existing and renewing members',
		card: true,
		loggedin: false,
		loggedout: true,
		redirect: '/member',
		icon: <PersonIcon />,
	},
	login_as : {
		path: "/login/as",
		title: "Log in as",
		loggedin: false,
		loggedout: true,
		redirect: '/member',
	},
	login_reset_password: {
		path: "/login/reset-password",
		title: "Request password reset",
		loggedin: false,
		loggedout: true,
		redirect: '/member',
	},
	login_retrieve_member_no: {
		path: "/login/retrieve-member-no",
		title: "Retrieve member number",
		loggedin: false,
		loggedout: true,
		redirect: '/member',
	},
	login_retrieve_member_details: {
		path: "/login/retrieve-member-details",
		title: "Retrieve member details",
		loggedin: false,
		loggedout: true,
		redirect: '/member',
	},
	logout: {
		path: "/logout",
		title: "Logout",
		card: true,
		loggedin: true,
		loggedout: false,
		redirect: "/",
		icon: <HighlightOffIcon />,
	},
	join: {
		path: "/join",
		title: "Join",
		subtext: 'New members',
		card: true,
		loggedin: false,
		loggedout: true,
		redirect: '/member',
		icon: <PersonAddIcon />,
	},
	contact: {
		path: "/contact",
		title: "Contact us",
		card: true,
		loggedin: true,
		loggedout: true,
		icon: <PhoneIcon />,
	},
	reset_password: {
		path: "/reset-password",
		title: "Reset password",
		loggedin: true, // I guess...?
		loggedout: true,
	},
};

export default RouteConstants